import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.instance = new TomSelect(this.selectTarget, {
      plugins: ["remove_button"],
      onItemAdd: function(){
        this.setTextboxValue("")
        this.refreshOptions()
      },
      maxItems: 3,
      hidePlaceholder: true,
      create: false,
    })
  }

  setupTomSelect(setupFn) {
    setupFn(this.instance)
  }

  enable() {
    this.selectTarget.disabled = false

    this.instance.enable()
  }

  disconnect() {
    this.instance.destroy()
  }
}
